import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import { Backdrop, Button, CircularProgress, Container, Typography } from "@mui/material";
import SkeletonLoading from "../../../components/SkeletonLoading";
import '../../../styles/AppCss.css'
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Padding, PaletaColor } from "../../../styles/StylesConstantes";
import { Add, Delete, Edit } from "@mui/icons-material";
import { getBeneficios } from "../../../api/ApiService";
import { useNavigate } from "react-router-dom";
import BeneficiosHeader from "./components/BeneficiosHeader";
import BeneficiosTableComponent from "./components/BeneficiosTableComponent";
import BeneficiosFiltrosComponents from "./components/BeneficiosFiltrosComponents";



function BeneficiosPage() {
  const [loading, setLoading] = useState(false);
  const [dataBeneficios, setDataBeneficios] = useState([]);
  const [loadingCargar, setLoadingCargar] = useState(false);
  const [metaPaginacion, setMetaPaginacion] = useState({
    current_page: 1,
    per_page: 10,
    total: 0,
    last_page: 1
  });
  const [perPage, setPerPage] = useState(10);
  const [statusFilter, setStatusFilter] = useState("todos");
  const [searchFilter, setSearchFilter] = useState("");
  const [idBeneficioDelete, setIdBeneficioDelete] = useState(null);
  const [showDeleteBeneficioModal, setShowDeleteBeneficioModal] = useState(false);



  const stateToken = useSelector(state => state.reducerGlobal.token);

  let history = useNavigate();






  useEffect(() => {
    const timeOutId = setTimeout(() => {
      if (searchFilter.length > 2) {

        handleApiFiltrarBeneficiosTituloEstado(searchFilter, statusFilter);
      } else {
        handleApiFiltrarBeneficios(1);
      }
    }, 1500);
    return () => clearTimeout(timeOutId);
  }, [stateToken, searchFilter, statusFilter, perPage]);
















  //=================================================================================================funcion para ver los locales adheridos, obtener el id
  const handleVerLocales = (id, row) => {
    history(`/app/admin/beneficios-locales/${id}`, {
      state: {
        data: row,
      }
    });
  };


  //=================================================================================================funcion para editar, obtener el id
  const handleEditClick = (item) => {
    console.log('Edit', item);
    history(`/app/admin/beneficio-editar/${item.id}`);
  };

  //=================================================================================================funcion para editar, obtener el id
  const handleVer = (item) => {
    console.log('Edit', item);
    history(`/app/admin/beneficio-detalle/${item.id}?mode=view`);
  };



  //=================================================================================================funcion para ir a la pantalla de agregar
  const handleAddBeneficio = () => {
    history('/app/admin/beneficios-agregar');
  };











  //============================================================ funcion para filtrar por estado y nombre
  const handleApiFiltrarBeneficiosTituloEstado = (titulo, estado) => {

    let body = {
      page: 1,
      per_page: perPage,
      estado: estado,
      titulo: titulo
    };
    console.log("body-handleApiFiltrarLocales", body);


    setLoadingCargar(true);

    getBeneficios(stateToken?.access_token, body)
      .then(response => {
        // console.log("response==>getBeneficios", response);

        setLoadingCargar(false);
        setLoading(true);

        if (response?.data?.data?.length > 0) {
          setDataBeneficios(response?.data?.data);
          setLoading(true);
        } else {
          setDataBeneficios([]);
          setLoading(true);
        }

        setMetaPaginacion({
          current_page: response?.data?.current_page,
          per_page: response?.data?.per_page,
          total: response?.data?.total,
          last_page: response?.data?.last_page
        });


      })
      .catch(error => {
        console.log("error==>getBeneficios", error);
        setDataBeneficios([]);
        setLoading(true);
        setLoadingCargar(false);
      })
  };






  //============================================================ funcion para filtrar por estado y nombre
  const handleApiFiltrarBeneficios = (page = 1) => {

    let body = {
      page: page,
      per_page: perPage,
      // estado: statusFilter,
      nombre: searchFilter
    };
    // console.log("body-handleApiFiltrarLocales", body);


    setLoadingCargar(true);

    getBeneficios(stateToken?.access_token, body)
      .then(response => {
        console.log("response==>getBeneficios", response?.data?.data);

        setLoadingCargar(false);
        setLoading(true);



        if (response?.data?.data?.length > 0) {
          setDataBeneficios(response?.data?.data);
          setLoading(true);
        } else {
          setDataBeneficios([]);
          setLoading(true);
        }

        setMetaPaginacion({
          current_page: response?.data?.current_page,
          per_page: response?.data?.per_page,
          total: response?.data?.total,
          last_page: response?.data?.last_page
        });


      })
      .catch(error => {
        console.log("error==>getBeneficios", error);
        setDataBeneficios([]);
        setLoading(true);
        setLoadingCargar(false);
      })
  };



  // funcion para setear la cantidad por pagina
  const handlePerPageChange = (newPerPage) => {
    setPerPage(newPerPage);
  };



  const handleOpenModalDeleteBeneficio = (idBeneficio) => {
    setIdBeneficioDelete(idBeneficio);
    setShowDeleteBeneficioModal(true);
  };



  const handleSearchChange = (value) => {
    setSearchFilter(value);
  };


  return (
    <HeaderCustom>
      <div className="min-h-screen bg-gray-100 p-6">
        {loading ? (
          <div className="max-w-7xl mx-auto">

            <BeneficiosHeader
              title="Beneficios"
              subtitle="Administra y supervisa los beneficios de la plataforma."
              handleAdd={handleAddBeneficio}
            />




            <div>

              <BeneficiosFiltrosComponents
                searchValue={searchFilter}
                onSearchChange={handleSearchChange}


              // statusFilter={statusFilter}
              // onStatusChange={handleStatusChange}
              // statusOptions={statusOptions}
              />



              <BeneficiosTableComponent
                data={dataBeneficios}
                metaPaginacion={metaPaginacion}
                onPageChange={handleApiFiltrarBeneficios}
                perPage={perPage}
                onPerPageChange={handlePerPageChange}
                handleEditarItem={handleEditClick}
                handleVerDetalle={handleVer}
                // handleOpenModalDelete={handleOpenModalDeleteBeneficio}
              />

            </div>


          </div>
        ) : (
          <div className="bg-white rounded-xl shadow-md p-8">
            <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
            <div className="space-y-4">
              <div className="h-10 bg-gray-200 rounded animate-pulse" />
              <div className="h-10 bg-gray-200 rounded animate-pulse" />
              <div className="h-24 bg-gray-200 rounded animate-pulse" />
            </div>
          </div>
        )}



        <Backdrop open={loadingCargar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>


    </HeaderCustom>
  );
}
export default BeneficiosPage;